import React from 'react';
import CapacityPlantTemplate from '../../components/CapacityPlantTemplate';
import { capacityPlants } from '../../data/capacityPlants';

const WaterPlant60BPM = () => (
  <CapacityPlantTemplate plant={capacityPlants['/60-bpm-water-plant']} path="/60-bpm-water-plant" />
);

export default WaterPlant60BPM;
